import Vue from 'vue/dist/vue.esm.js';
import ActionCableVue from 'actioncable-vue';

import DownloadManagerComponent from 'components/channels/DownloadManager.vue';

let hostname = window.location.hostname;
let whenServedOnLocalhost = hostname.includes('localhost');
whenServedOnLocalhost ? hostname = 'localhost:3000' : null;

// Secure HTTPS connections require web socket protocols to also use the secure version
let webSocketConnectionProtocol = 'ws:';
let whenSecureConnection = location.protocol.includes('https:');
whenSecureConnection ? webSocketConnectionProtocol = 'wss:' : null;

Vue.use(ActionCableVue, {
  debug: whenServedOnLocalhost,
  debugLevel: 'error',
  connectionUrl: `${webSocketConnectionProtocol}//${hostname}/cable`,
  connectImmediately: true,
});

Vue.component('download-manager', DownloadManagerComponent);

function initializeDownloadManager() {
  const downloadManagerEl = document.getElementById('download-manager');

  if (downloadManagerEl && !downloadManagerEl.__vue__) {
    new Vue({
      el: '#download-manager',

      beforeMount() {
        this.user = this.$el.dataset.user;
      },

      template: `
              <download-manager></download-manager>
          `,
    });
  } else if (!downloadManagerEl) {
    console.warn('[DownloadManager] Element #download-manager not found in DOM');
  } else {
    console.warn('[DownloadManager] Vue instance already exists on element');
  }
}

// If DOM is already loaded (can happen with defer), initialize immediately
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeDownloadManager);
} else {
  initializeDownloadManager();
}
